import api from './axios';

export function getIncomeHistory(months = 12) {
  return api.get('/income-history', { params: { months } }).then(r => r.data);
}

export function getIncomeForMonth(year, month) {
  return api.get(`/income-history/${year}/${month}`).then(r => r.data);
}

export function saveIncomeEntry(year, month, income) {
  return api.post('/income-history', { year, month, income }).then(r => r.data);
}

export function deleteIncomeEntry(year, month) {
  return api.delete(`/income-history/${year}/${month}`);
}
